// extracted by mini-css-extract-plugin
export default {"Loader":"Duplicate_Loader__RGz0f"};